import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button } from '@ctct/payflow-ui';

import './submission-actions.scss';

interface Props {
  isLoading: boolean;
  allowSave: boolean;
  onUpdateInfo(): void;
  onCancel(): void;
}

export const SubmissionActions = ({ isLoading, allowSave, onUpdateInfo, onCancel }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('payflow-presentation payflow-submission-actions', isLoading && 'is-loading')}>
      <Button disabled={isLoading || !allowSave} onClick={onUpdateInfo} size="medium" variant="primary">
        {t('billing-info-page.save')}
      </Button>
      <Button onClick={onCancel} size="medium" variant="secondary">
        {t('billing-info-page.exit')}
      </Button>
    </div>
  );
};
